import React, { Component } from 'react';

class Team extends Component {

  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  getTranslatedContent(langCode){
    if(!["he", "en"].includes(langCode)){ // setting langCode to "en" if invalid code given
      langCode = "en";
    }
    var retVal;
    if(langCode === "he"){
      retVal = <>

        <p /><h5>&nbsp;&nbsp;חברים עיקריים</h5><p />
        <ul>
          <li>
            <b>
              משה אסקוט:
            </b>&nbsp;
            מייסד ואדריכל תוכנה ראשי
          </li>
          <li>
            <b>
              סטייסי אסקוט:
            </b>&nbsp;
            עוזרת תמיכה בכירה
          </li>
        </ul>
        <p /><h5>&nbsp;&nbsp;חברי עבר</h5><p />
        <ul>
          <li>
            <b>
              מרים אסקוט:
            </b>&nbsp;
            עוזרת מחקר, הזנת נתונים ויצירה
          </li>
          <li>
            <b>
              ארי אברמוביץ:
            </b>&nbsp;
            מתמחה בתכנות ומפתח תוכנה
          </li>
          <li>
            <b>
              יעקב לוונשטיין:
            </b>&nbsp;
            מתמחה בתכנות
          </li>
          <li>
            <b>
              ישראל לוונטל:
            </b>&nbsp;
            מתמחה בתכנות
          </li>
          <li>
            <b>
              שלמה גורדון:
            </b>&nbsp;
            מתמחה בתכנות
          </li>
          <li>
            <b>
              הרב שמחה שאום:
            </b>&nbsp;
            מתמחה בתכנות
          </li>
          <li>
            <b>
              שם טוב שפירא:
            </b>&nbsp;
            מפתח תוכנה
          </li>
          <li>
            <b>
              אהרן פארנטראג:
            </b>&nbsp;
            מתמחה בתכנות
          </li>
          <li>
            <b>
              עדינה אסקוט:
            </b>&nbsp;
            מתמחה בתכנות
          </li>
        </ul>
      </>
    } else if (langCode === "en") {
      retVal = <>
 
        <p /><h5>&nbsp;&nbsp;Principal Members</h5><p />
        <ul>
          <li><b>Moshe Escott</b>: founder and chief software architect</li>
          <li><b>Stacey Escott</b>: senior support assistant</li>
        </ul>
        <p /><h5>&nbsp;&nbsp;Past Members</h5><p />
        <ul>
          <li><b>Miriam Escott</b>: research, data entry and creative assistant</li>
          <li><b>Ari Abramowitz</b>: programming intern and software developer</li>
          <li><b>Yaakov Lowenstein</b>: programming intern</li>
          <li><b>Yisrael Lowenthal</b>: programming intern</li>
          <li><b>Shlomo Gordon</b>: programming intern</li>
          <li><b>Rabbi Simcha Schaum</b>: programming intern</li>
          <li><b>Shem Tov Shapiro</b>: software developer</li>
          <li><b>Aaron Farntrog</b>: programming intern</li>
          <li><b>Adina Escott</b>: programming intern</li>
        </ul>

      </>
    }
    return retVal;
  }
  
  render() {
    return <>
      {this.getTranslatedContent(this.props.langCode)}
    </>
  }
}

export default Team;